<template>
  <!-- 災害対策患者一覧 -->
  <div id="AppDisasterPatientList">
    <!-- 余白 -->
    <div style="height: 10px" />

    <div class="columns">
      <div class="column is-two-thirds" style="text-align: left">
        <!-- TODO: 表示条件 -->
        <b-button
          v-if="
            positionCode == positionIdMap.sales ||
            positionCode == positionIdMap.gss ||
            positionCode == positionIdMap.branchMgr ||
            positionCode == positionIdMap.blockMgr ||
            positionCode == positionIdMap.gssMgr ||
            positionCode == positionIdMap.soc ||
            roleId == roleMap.systemManager
          "
          class="button is-primary has-text-centered"
          native-type="button"
          position="is-right"
          v-on:click="showSelectPatient()"
        >
          患者追加
        </b-button>
        <select-patient-form
          v-model="isShowSelectPatient"
          @selected="addPatients($event)"
        />
        <b-button
          v-if="
            positionCode == positionIdMap.sales ||
            positionCode == positionIdMap.gss ||
            positionCode == positionIdMap.branchMgr ||
            positionCode == positionIdMap.blockMgr ||
            positionCode == positionIdMap.gssMgr ||
            positionCode == positionIdMap.soc ||
            roleId == roleMap.systemManager
          "
          class="button is-primary has-text-centered"
          native-type="button"
          position="is-right"
          v-on:click="showSelectPatientForCustomerList()"
        >
          得意先から患者追加
        </b-button>
        <g-select-patient-customer-form
          v-if="isShowSelectPatientForCustomerList"
          v-model="isShowSelectPatientForCustomerList"
          v-on:add-patient="addPatientList"
          v-bind:fixedDivision="customer.patient.code"
        />
        <b-upload v-model="patientsFile" v-on:input="uploadPatientsFile()">
          <a
            v-if="
              positionCode == positionIdMap.gss ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.soc ||
              roleId == roleMap.systemManager
            "
            class="button is-primary"
            style="width: 270px"
          >
            <b-icon icon="upload"></b-icon>
            <span>患者情報アップロード</span>
          </a>
        </b-upload>
        <b-button
          class="button is-primary has-text-centered"
          icon-left="google-maps"
          native-type="button"
          position="is-right"
          :disabled="checkedRows.length < 1"
          v-on:click="doShowGoogleMapChecked"
        >
          地図表示
        </b-button>
        <b-button
          v-if="
            positionCode == positionIdMap.sales ||
            positionCode == positionIdMap.gss ||
            positionCode == positionIdMap.branchMgr ||
            positionCode == positionIdMap.blockMgr ||
            positionCode == positionIdMap.gssMgr ||
            positionCode == positionIdMap.soc ||
            roleId == roleMap.systemManager
          "
          class="button is-primary has-text-centered"
          native-type="button"
          position="is-right"
          :disabled="checkedRows.length < 1"
          v-on:click="changeEmergencyLevel()"
        >
          緊急連絡レベル設定
        </b-button>
        <emergencyLevel-modal
          v-model="isEmergencyLevelChangeModalActive"
          v-bind:office-code="data.emergencyLevel"
          v-on:selected="updateEmergencyLevel($event)"
        ></emergencyLevel-modal>
        <b-button
          v-if="
            positionCode == positionIdMap.sales ||
            positionCode == positionIdMap.gss ||
            positionCode == positionIdMap.branchMgr ||
            positionCode == positionIdMap.blockMgr ||
            positionCode == positionIdMap.gssMgr ||
            positionCode == positionIdMap.soc ||
            roleId == roleMap.systemManager
          "
          class="button is-primary has-text-centered"
          native-type="button"
          position="is-right"
          :disabled="checkedRows.length < 1"
          v-on:click="changeStaff()"
        >
          対応者設定
        </b-button>
        <staffChange-modal
          v-model="isStaffChangeModalActive"
          v-bind:title="'対応者変更'"
          v-bind:office-master-list="referenceEnableOffice"
          v-on:staff-change-event="staffChanged($event)"
        ></staffChange-modal>
      </div>

      <div class="column">
        <div class="columns">
          <div class="column">
            <b-field>
              <b-input
                v-model="searchStaffName"
                style="width: 100%"
              ></b-input>
              <b-button
                style="float: right; bottom: 0"
                class="button is-primary has-text-centered"
                icon-left="account-switch"
                native-type="button"
                v-on:click="changeSearchStaff"
              ></b-button>
              <staffChange-modal
                v-model="isSearchStaffChangeModalActive"
                v-bind:title="'対応者検索'"
                v-bind:office-master-list="referenceEnableOffice"
                v-on:staff-change-event="searchStaffChanged($event)"
              ></staffChange-modal>
            </b-field>
          </div>
          <div class="column is-3">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search()"
            >
              検索する
            </b-button>
          </div>
        </div>
      </div>

      <div class="column">
        <b-field
          horizontal
          label="表示件数"
          style="float: right; white-space: nowrap"
        >
          <b-select position="is-right" v-model="perPage">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </b-select>
        </b-field>
      </div>
    </div>

    <!-- 一覧 -->
    <div>
      <b-table
        :v-show="data"
        :data="data"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :pagination-size="paginationSize"
        :default-sort-direction="sortOrder"
        :default-sort="sortItem"
        detailed
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        backend-sorting
        @sort="sort"
        @page-change="changePage"
      >
        <template v-if="props.row" slot-scope="props">
          <b-table-column
            field="recipientCode"
            label="患者コード"
            sortable
            centered
          >
            {{ props.row.recipientCode }}
          </b-table-column>
          <b-table-column
            field="recipientName"
            label="患者名"
            sortable
            centered
          >
            {{ props.row.recipientName }}
          </b-table-column>
          <b-table-column
            field="recipientNameKana"
            label="患者名（カナ）"
            sortable
            centered
          >
            {{ props.row.recipientNameKana }}
          </b-table-column>
          <b-table-column
            field="phoneNumber"
            label="電話番号"
            sortable
            centered
          >
            {{ props.row.phoneNumber }}
          </b-table-column>
          <b-table-column
            field="emergencyLevel"
            label="緊急連絡レベル"
            sortable
            centered
          >
            {{ props.row.emergencyLevel | anpyLevelFilter }}
          </b-table-column>
          <b-table-column field="staffName" label="対応者" sortable centered>
            {{ props.row.staffName }}
          </b-table-column>
          <b-table-column field="officeName" label="営業所" sortable centered>
            <span
              v-for="officeName in getOfficeName(
                props.row.patientValues.officeName
              )"
              :value="officeName"
              :key="officeName"
            >
              {{ officeName }}
              <br />
            </span>
          </b-table-column>
          <b-table-column
            field="contactStatus"
            label="ステータス"
            sortable
            centered
            :style="contactStatusStyle(props.row.contactStatus)"
          >
            <b-select
              v-if="
                positionCode == positionIdMap.sales ||
                positionCode == positionIdMap.branchMgr ||
                positionCode == positionIdMap.blockMgr ||
                positionCode == positionIdMap.gssMgr
              "
              v-model="props.row.contactStatus"
              expanded
            >
              <option
                v-for="status in statusMaster"
                :value="status.code"
                :key="status.code"
              >
                {{ status.name }}
              </option>
            </b-select>
            <span v-else style="color: white">
              {{ props.row.contactStatus | disasterContactStatusFilter }}
            </span>
          </b-table-column>
          <b-table-column
            field="supportStatus"
            label="対応状況"
            sortable
            centered
            :style="supportStatusStyle(props.row.supportStatus)"
          >
            <b-select
              v-if="
                positionCode == positionIdMap.sales ||
                positionCode == positionIdMap.branchMgr ||
                positionCode == positionIdMap.blockMgr ||
                positionCode == positionIdMap.gssMgr
              "
              v-model="props.row.supportStatus"
              expanded
            >
              <option
                v-for="support in supportMaster"
                :value="support.code"
                :key="support.code"
              >
                {{ support.name }}
              </option>
            </b-select>
            <span v-else style="color: white">
              {{ props.row.supportStatus | disasterContactStatusFilter }}
            </span>
          </b-table-column>

          <b-table-column
            v-if="
              positionCode == positionIdMap.sales ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr
            "
            field="configuration"
            label="対応記録"
          >
            <b-button
              class="button is-primary has-text-centered"
              :icon-left="
                props.row.content || props.row.result ? 'comment-check-outline' : 'comment-outline'
              "
              native-type="button"
              v-on:click="changeDisasterSupport(props.row)"
            ></b-button>
          </b-table-column>

          <disaster-support-modal
            v-if="props.row.isDisasterSupportModalActive"
            v-model="props.row.isDisasterSupportModalActive"
            v-bind:disaster-support="props.row"
            v-on:disaster-support-event="disasterSupportChanged"
          ></disaster-support-modal>

          <b-table-column
            v-if="
              positionCode == positionIdMap.sales ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.salesStrategy
            "
            field="configuration"
            label="保存"
          >
            <b-button
              class="button is-primary has-text-centered"
              icon-left="content-save"
              native-type="button"
              v-on:click="save(props.row)"
            ></b-button>
          </b-table-column>
          <b-table-column
            v-if="
              positionCode == positionIdMap.sales ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.soc ||
            roleId == roleMap.systemManager
            "
            field="configuration"
            label="削除"
          >
            <b-button
              class="button is-primary has-text-centered"
              icon-left="account-remove"
              native-type="button"
              v-on:click="deletePatient(props.row)"
            ></b-button>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <div class="content">
            <span style="margin-left: 10px; font-weight: bold; font-size: 14px">
              住所：
            </span>
            <span style="font-weight: bold; font-size: 14px">
              〒{{ props.row.postCode }} {{ props.row.address }}
            </span>
            <div style="height: 10px" />
            <table style="table-layout: fixed">
              <template v-for="(prodItem, index) in props.row.productDetails">
                <tr v-bind:key="prodItem.index">
                  <th style="width: 150px" rowspan="3">
                    機器情報 {{ index + 1 }}
                  </th>
                  <th style="width: 150px">機器名</th>
                  <td>
                    {{ prodItem.productName }} ({{ prodItem.productCode }})
                  </td>
                </tr>
                <tr v-bind:key="prodItem.index">
                  <th>シリアルNo.</th>
                  <td>{{ prodItem.serialNumber }}</td>
                </tr>
                <tr v-bind:key="prodItem.index">
                  <th>医療機関名</th>
                  <td>
                    {{ prodItem.hospitalName }} ({{ prodItem.hospitalCode }})
                  </td>
                </tr>
              </template>
              <tr></tr>
            </table>
          </div>
        </template>
      </b-table>
    </div>

    <googleMap-form
      v-model="isShowGoogleMap"
      v-bind:marker="addressList"
    ></googleMap-form>

    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import selectEmergencyLevelTemplate from "./common/EmergencyLevelChooser";
import staffChooserTemplate from "./common/StaffChooser";
import disasterSupportTemplate from "../components/common/DisasterSupport";
import selectPatientTemplate from "../components/common/SelectPatient";
import selectPatientForCustomerListTemplate from "../components/common/SelectPatientForCustomerList";
import { DISASTER_CONTACT_STATUS_MAP } from "../utils/disaster";
import { DISASTER_SUPPORT_STATUS_MAP } from "../utils/disaster";
import MapForm from "../components/common/Map.vue";
import * as customer from "../utils/customer";
import * as user from "../utils/user";

export default {
  props: ["disasterId"],

  components: {
    "emergencyLevel-modal": selectEmergencyLevelTemplate,
    "staffChange-modal": staffChooserTemplate,
    "disaster-support-modal": disasterSupportTemplate,
    "select-patient-form": selectPatientTemplate,
    "select-patient-customer-form": selectPatientForCustomerListTemplate,
    "googleMap-form": MapForm,
  },

  data() {
    let data = [];
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const referenceEnableOffice = JSON.parse(
      sessionStorage.getItem("referenceEnableOffice")
    );
    let positionCode = userInfo.positionCode;
    let positionIdMap = user.POSITION_ID_MAP;
    let roleId = userInfo.roleId;
    let roleMap = user.ROLE_ID_MAP;

    return {
      data,
      userInfo,
      // ページ
      isPaginated: true,
      perPage: 10,
      currentPage: 1,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      // ソート
      sortOrder: "asc",
      sortItem: "recipientCode",
      // 選択
      checkedRows: [],
      // 地図表示
      addressList: [],
      isShowGoogleMap: false,
      // 緊急連絡レベル変更
      isEmergencyLevelChangeModalActive: false,
      emergencyLevel: null,
      // 担当者変更
      isStaffChangeModalActive: false,
      staffCode: null,
      staffName: null,
      // 対応記録
      updateDisasterSupport: null,
      // 患者追加
      isShowSelectPatient: false,
      isShowSelectPatientForCustomerList: false,
      isSelectPatientForCustomerActive: false,
      statusMaster: DISASTER_CONTACT_STATUS_MAP,
      supportMaster: DISASTER_SUPPORT_STATUS_MAP,
      addPatient: null,
      addTargetPatients: null,
      customer: customer.CUSTOMER_TYPE_MAP,
      // 参照可能営業所
      referenceEnableOffice: referenceEnableOffice,
      // 患者情報ファイル
      patientsFile: null,
      positionCode,
      positionIdMap,
      roleId,
      roleMap,
      // 対応者検索
      searchStaffName: null,
      isSearchStaffChangeModalActive: false,
    };
  },

  computed: {},

  filters: {},

  methods: {
    getOfficeName: function (value) {
      return value ? value.split(",") : "";
    },

    setDisasterPatientSupportsPOSTsucces: function (result) {
      this.showSuccess(result);
      return;
    },

    setDisasterPatientSupportsPOSTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    // 地図表示
    doShowGoogleMapChecked: function () {
      // 住所収集
      const addresses = [];
      for (const selected of this.checkedRows) {
        const target = {
          address: selected.address,
          name: selected.recipientName,
          patientZipCode: selected.postCode,
        };
        addresses.push(target);
      }

      // 地図表示
      this.addressList = addresses;
      this.isShowGoogleMap = true;
    },

    // 対応者変更
    changeStaff: function () {
      this.isStaffChangeModalActive = true;
    },
    staffChanged: function (staffInfo) {
      this.staffCode = staffInfo.id;
      this.staffName = staffInfo.staffName;

      // WebAPI呼び出し
      this.apiCall(
        this.setDisasterPatientSupportsPUT,
        this.setDisasterPatientSupportsPUTsucces,
        this.setDisasterPatientSupportsPUTerror
      );
    },

    // 対応者検索
    changeSearchStaff: function () {
      this.isSearchStaffChangeModalActive = true;
    },
    searchStaffChanged: function (staffInfo) {
      this.searchStaffName = staffInfo.staffName;
    },
    search: async function () {
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );
    },

    // 緊急連絡レベル変更
    changeEmergencyLevel: function () {
      this.isEmergencyLevelChangeModalActive = true;
    },
    updateEmergencyLevel: function (emergencyLevel) {
      this.emergencyLevel = emergencyLevel;

      // WebAPI呼び出し
      this.apiCall(
        this.setDisasterPatientSupportsPUT,
        this.setDisasterPatientSupportsPUTsucces,
        this.setDisasterPatientSupportsPUTerror
      );
    },

    setDisasterPatientSupportsPUT: function (client) {
      let apiRes;
      let body = {
        disasterId: this.disasterId,
        disasterSupportHistorys: [],
      };

      if (this.staffCode) {
        // 対応者更新
        let newData = {
          supportStaffCode: this.staffCode,
          supportStaffName: this.staffName,
        };

        for (const row of this.checkedRows) {
          body.disasterSupportHistorys.push({
            disasterSupportId: row.disasterSupportHistoryId,
            patientCode: row.recipientCode,
            newData: newData,
          });
        }

        this.staffCode = null;
        this.staffName = null;
      } else {
        // 緊急連絡レベル更新
        let newData = {
          emergencyLevel: "" + this.emergencyLevel.code,
        };

        for (const row of this.checkedRows) {
          body.disasterSupportHistorys.push({
            disasterSupportId: row.disasterSupportHistoryId,
            patientCode: row.recipientCode,
            newData: newData,
          });
        }

        this.emergencyLevel = null;
      }

      apiRes = client.apis.apiDisaster.setDisasterPatientSupportsPUT({ body });

      return apiRes;
    },

    setDisasterPatientSupportsPUTsucces: async function (result) {
      this.showSuccess(result);
      this.checkedRows = [];
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );

      return;
    },

    setDisasterPatientSupportsPUTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    setDisasterPatientSupportPUTsucces: function (result) {
      this.showSuccess(result);
      return;
    },

    // 患者追加
    showSelectPatient: function () {
      this.isShowSelectPatient = true;
    },
    showSelectPatientForCustomerList: function () {
      this.isShowSelectPatientForCustomerList = true;
    },

    // 対応記録
    changeDisasterSupport: function (row) {
      row.isDisasterSupportModalActive = true;
    },
    disasterSupportChanged: function (disasterSupport) {
      this.updateDisasterSupport = disasterSupport;

      // WebAPI呼び出し
      this.apiCall(
        this.setDisasterPatientSupportPUT,
        this.setDisasterPatientSupportPUTsucces,
        this.setDisasterPatientSupportPUTerror
      );
    },

    // 保存
    save: function (row) {
      this.saveRow = row;

      // WebAPI呼び出し
      this.apiCall(
        this.setDisasterPatientSupportPUT,
        this.setDisasterPatientSupportPUTsucces,
        this.setDisasterPatientSupportPUTerror
      );
    },

    setDisasterPatientSupportPUT: function (client) {
      let apiRes;
      let body;

      if (this.updateDisasterSupport) {
        body = {
          disasterId: this.disasterId,
          recipientCode: this.updateDisasterSupport.recipientCode,
          therapy: this.updateDisasterSupport.patientValues.therapy,
          disasterSupportHistoryId:
            this.updateDisasterSupport.disasterSupportHistoryId,
          content: this.updateDisasterSupport.content,
          result: this.updateDisasterSupport.result,
          patientSupportHistoryIds: this.updateDisasterSupport.patientValues.patientSupportHistoryIds ? 
            this.updateDisasterSupport.patientValues.patientSupportHistoryIds : null,
        };
        // 患者対応履歴登録用データ
        if (!body.patientSupportHistoryIds) {
          body.contactStatus = this.updateDisasterSupport.contactStatus;
          body.supportStatus = this.updateDisasterSupport.supportStatus;
          body.supportStaffCode = "" + this.updateDisasterSupport.supportStaffCode,
          body.supportStaffName = this.updateDisasterSupport.staffName,
          body.patientValues = this.updateDisasterSupport.patientValues;
          body.hospitalCodeList = [];
          for (const productDetail of this.updateDisasterSupport.productDetails) {
            let hospitalCode = body.hospitalCodeList.includes(productDetail.hospitalCode);
            if (!hospitalCode) {
              body.hospitalCodeList.push(productDetail.hospitalCode);
            }
          }
        }
        this.updateDisasterSupport = null;
      } else {
        const oldRec = this.oldData.find(
          (elem) =>
            elem.disasterSupportHistoryId ==
            this.saveRow.disasterSupportHistoryId
        );
        body = {
          disasterId: this.disasterId,
          recipientCode: this.saveRow.recipientCode,
          therapy: this.saveRow.patientValues.therapy,
          disasterSupportHistoryId: this.saveRow.disasterSupportHistoryId,
          contactStatus: this.saveRow.contactStatus,
          supportStatus: this.saveRow.supportStatus,
          patientSupportHistoryIds: this.saveRow.patientValues.patientSupportHistoryIds ? 
            this.saveRow.patientValues.patientSupportHistoryIds : null,
        };
        this.saveRow = null;
      }
      apiRes = client.apis.apiDisaster.setDisasterPatientSupportPUT({ body });

      return apiRes;
    },
    setDisasterPatientSupportPUTsucces: async function (result) {
      this.showSuccess(result);

      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );

      return;
    },
    setDisasterPatientSupportPUTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    // 削除
    deletePatient: async function (row) {
      this.deleteRow = row;
      const confiermRes = await this.showComfirmMessage(
        "この災害対応履歴を削除します。よろしいですか？"
      );
      if (confiermRes) {
        // WebAPI呼び出し
        this.apiCall(
          this.deleteDisasterPatientSupportPOST,
          this.deleteDisasterPatientSupportPOSTsucces,
          this.deleteDisasterPatientSupportPOSTerror
        );
      }
      return;
    },

    deleteDisasterPatientSupportPOST: function (client) {
      const apiRes = client.apis.apiDisaster.deleteDisasterPatientSupportPOST({
        body: {
          disasterId: this.disasterId,
          recipientCode: this.deleteRow.recipientCode,
          disasterSupportHistoryId: this.deleteRow.disasterSupportHistoryId,
          productDetails: this.deleteRow.productDetails,
        },
      });
      return apiRes;
    },

    deleteDisasterPatientSupportPOSTsucces: async function (result) {
      this.showSuccess(result);
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );
      return;
    },

    deleteDisasterPatientSupportPOSTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    addPatientList: async function (info) {
      this.addPatient = info;
      var excuteApi = this.setDisasterPatientSupportsPOST;
      var successCallBack = this.setDisasterPatientSupportsPOSTSuccess;
      var errorCallBack = this.setDisasterPatientSupportsPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);

      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );

      return;
    },

    addPatients: async function (patients) {
      this.addTargetPatients = patients;

      // API呼び出し
      await this.apiCall(
        this.setDisasterPatientSupportsPOST,
        this.setDisasterPatientSupportsPOSTsucces,
        this.setDisasterPatientSupportsPOSTerror
      );

      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );

      return;
    },

    setDisasterPatientSupportsPOST: function (client) {
      let apiRes;
      let body = {
        addMode: "",
        disasterId: this.disasterId,
        patientList: [],
      };
      if (this.addPatient) {
        // 得意先から追加
        body.addMode = "customer";
        body.patientList.push({
          patientCode: this.addPatient.patient.code,
          patientName: this.addPatient.patient.name,
          phoneNumber: this.addPatient.patient.phoneNumber,
          contactStatus: DISASTER_CONTACT_STATUS_MAP.noContact.code,
          supportStatus: null,
          postCode: this.addPatient.patient.postCode ? this.addPatient.patient.postCode : "",
          address: this.addPatient.patient.address,
          productDetails: [
            {
              therapy: this.addPatient.therapy,
              productName: this.addPatient.product.productName,
              productCode: this.addPatient.product.productCode,
              hospitalName: this.addPatient.hospital.name,
              hospitalCode: this.addPatient.hospital.code,
            },
          ],
        });

        this.addPatient = null;
      } else {
        // 患者追加
        body.addMode = "patient";
        for (const patient of this.addTargetPatients) {
          let productDetails = [];

          for (const product of patient.productDetail) {
            productDetails.push({
              productName: product.productName,
              productCode: product.productCode,
              hospitalName: product.hospitalName,
              hospitalCode: product.hospitalCode,
              serialNumber: product.serialNumber,
            });
          }

          body.patientList.push({
            officeCode: patient.officeCode,
            officeName: patient.officeName,
            patientCode: patient.patientCode,
            patientName: patient.patientName,
            patientNameKana: patient.patientNameKana,
            phoneNumber: patient.patientPhone,
            emergencyLevel: patient.emergencyLevel,
            contactStatus: DISASTER_CONTACT_STATUS_MAP.noContact.code,
            supportStatus: null,
            supportStaffCode: patient.userId,
            supportStaffName: patient.staffName,
            oldContactStatus: null,
            oldSupportStatus: null,
            postCode: patient.postCode ? patient.postCode : "",
            address: patient.address,
            therapy: patient.therapy,
            productDetails: productDetails,
          });
        }

        this.addTargetPatients = null;
      }
      apiRes = client.apis.apiDisaster.setDisasterPatientSupportsPOST({ body });

      return apiRes;
    },

    setDisasterPatientSupportsPOSTSuccess: function (result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      return;
    },

    setDisasterPatientSupportsPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    getDisasterPatientSupportsGET: function (client) {
      const apiRes = client.apis.apiDisaster.getDisasterPatientSupportsGET({
        disasterId: this.disasterId,
        limit: this.perPage,
        currentPage: this.currentPage,
        sortBy: this.sortItem,
        sortDisc: this.sortOrder == "desc" ? true : false,
        searchStaffName: this.searchStaffName,
      });
      return apiRes;
    },

    getDisasterPatientSupportsGETsuccess: function (result) {
      //WebAPI応答内容を画面に設定
      this.currentPage = result.obj.currentPage;
      // 前後のページに空行設定
      const prevPages = Array(this.perPage * (this.currentPage - 1));
      prevPages.fill();
      const nextPageItemNum =
        result.obj.totalCount - this.perPage * this.currentPage;
      const nextPages = Array(nextPageItemNum > 0 ? nextPageItemNum : 0);
      nextPages.fill();
      const data = [...prevPages, ...result.obj.patientList, ...nextPages];
      this.data.splice(0);
      for (let row of data) {
        if (row) {
          row.isDisasterSupportModalActive = false;
        }
        this.data.push(row);
      }
      this.oldData = JSON.parse(JSON.stringify(result.obj.patientList));
      return;
    },

    getDisasterPatientSupportsGETerror: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    changePage: async function (page) {
      this.checkedRows = [];
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );
      return;
    },

    sort: async function (field, order) {
      this.sortItem = field;
      this.sortOrder = order;
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );
      return;
    },

    uploadPatientsFile: function () {
      var excuteApi = this.uploadPatientsFilePOST;
      var successCallBack = this.uploadPatientsFileSuccess;
      var errorCallBack = this.uploadPatientsFileError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },

    uploadPatientsFilePOST: function (client) {
      return client.apis.apiDisaster.uploadDisasterPatientSupportsPOST({
        disasterId: this.disasterId,
        upfile: this.patientsFile,
      });
    },

    uploadPatientsFileSuccess: async function (result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.patientsFile = null;

      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );
    },

    uploadPatientsFileError: function (result) {
      this.showErrorMessage(result);
      this.patientsFile = null;
    },

    contactStatusStyle: function (status) {
      let style = "background-color: ";
      switch (status) {
        case this.statusMaster.noContact.code:
        case this.statusMaster.again.code:
          style += "#FF3860";
          break;
      
        case this.statusMaster.completed.code:
          style += "#209CEE";
          break;
      }

      return style;
    },

    supportStatusStyle: function (status) {
      let style = "background-color: ";
      switch (status) {
        case this.supportMaster.needService.code:
          style += "#FF3860";
          break;
      
        case this.supportMaster.completed.code:
          style += "#209CEE";
          break;
        
        default:
          style = "";
          break;
      }

      return style;
    },
  },

  created: async function () {
    await this.apiCall(
      this.getDisasterPatientSupportsGET,
      this.getDisasterPatientSupportsGETsuccess,
      this.getDisasterPatientSupportsGETerror
    );

    return;
  },

  watch: {
    perPage: async function () {
      await this.apiCall(
        this.getDisasterPatientSupportsGET,
        this.getDisasterPatientSupportsGETsuccess,
        this.getDisasterPatientSupportsGETerror
      );

      return;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppDisasterPatientList.vue